export default "__VITE_ASSET__b9c2bb70__"